import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator function to check if a date in the format MM/DD/YYYY is valid.
 * The date must be in the format MM/DD/YYYY and represent a valid date.
 */
export function maskedDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors => {
    if (!control.value || control.value.length !== 10) {
      return null;
    }

    const [month, day, year] = control.value.split('/').map(Number);
    const date = new Date(year, month - 1, day);

    const isValid = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;

    return isValid ? null : { invalidDate: true };
  };
}
